const rootActionPath = 'core/AcquisitionBonusInfoBarBanner';

export const ACQUISITION_BONUS_INFO_BAR_BANNER_VIEW = `${rootActionPath}/VIEW`;
